export default __webpack_public_path__ + "static/media/hide.77b4a6d8.svg";